import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTreeModule} from '@angular/material/tree';
import { MatCardModule } from '@angular/material/card';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatBadgeModule} from '@angular/material/badge';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
//import { LoaderComponent } from 'src/app/middleware/shared/loader/components/loader.component';
import { AddNewComponent } from 'src/app/middleware/common/addnew/addnew.component';
import { SharedModule } from 'src/app/middleware/shared/shared.module';
import { FormsService } from '../eSignature/services/forms.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from 'src/app/middleware/authentication/interceptor/auth-interceptor';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgSelectModule } from '@ng-select/ng-select';
import { SnfReportingComponent } from './sfnReporting.component';
import { snfreportingRoutingModule } from './sfnReporting-routing.module';

@NgModule({
  declarations: [SnfReportingComponent],
  imports: [
    CommonModule,
    SharedModule,
    snfreportingRoutingModule,
    MatIconModule,
    FlexLayoutModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatTreeModule,
    MatCardModule,
    MatProgressBarModule,
    MatBadgeModule,
    NgApexchartsModule,
    MatProgressSpinnerModule,
    NgSelectModule
  ],
  providers: [   
    //LoaderService,
    //FormsService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    {provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},  
  ],
  exports: [
   
  ]
})
export class SfnReportingModule  { }
